
import React, { useEffect } from "react"
import TopBar from "../helpers/TopBar"
import Footer from "../helpers/Footer"
import "antd/dist/antd.less"
import "./styles.less"

type Props = {
  children: any
  menu?: boolean
  footer?: boolean
}

declare var ga: any

const MainWrapper2 = ({ children, menu, footer }: Props) => {
  useEffect(() => {
    if (typeof ga == "function") {
      ga("set", "location", window.location.href)
      ga("send", "pageview")
    }
  }, [])

  return (
    <>
      {menu && <TopBar />}
      <div>{children}</div>
      {footer && <Footer />}
    </>
  )
}

export default MainWrapper2
